import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { AuthService, IncidenciasService, MainService } from "../../services/";
import { OpenDialogDirective } from "../../directives/";
import { MediaMatcher } from "@angular/cdk/layout";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { imagenes, titulos } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { FinanciamientoApiService } from "src/app/services/financiamiento-reusable.service";
import { Globals } from "src/app/globals";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  @ViewChild(OpenDialogDirective) openDialog;
  user: any;
  route: string;
  mobileQuery: MediaQueryList;
  @BlockUI() blockUI: NgBlockUI;
  admin_etic: number;
  admin_com: number;
  code_title: number;
  title_option: string = "#";
  existe: number;
  estadoTramite: string;
  existeBand: boolean;
  errorApiConsulta: boolean = false;
  recibos: any[] = [];
  error: boolean = false;
  lugar: string;
  nro_sumininstro: string;
  dni: string;
  tip_doc: string;
  tip_sol: string;

  token = "";
  showFiller = true;
  suministro: number;
  tipo_documento: string;
  numero_documento: string;
  disabledMenu: string;
  nonePoint: boolean;


  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService,
    private mainService: MainService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private financiamientoApiService: FinanciamientoApiService,
    private incidenceService: IncidenciasService,
    private toastr: ToastrService,
    public globals: Globals
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    let url = this.router.url;
    this.route = url.replace("/", "");
    this.reloadMensaje();
  }

  ngOnInit() {
    sessionStorage.setItem('disabledMenu', '0');
    if (sessionStorage.getItem('registroCompleto') === '1') {
      this.router.navigate(['']);
    } 
    this.disabledMenu = sessionStorage.getItem('disabledMenu');
    console.log('disabled menu ...' + this.disabledMenu)
    this.suministro = Number(sessionStorage.getItem('suministro'));
    this.tipo_documento = sessionStorage.getItem('tipoDocumento');
    this.numero_documento = sessionStorage.getItem('numeroDocumento');
    this.globals.tip_docum = this.tipo_documento !== null ? this.tipo_documento : '';
    this.globals.suministro = this.suministro !== null ? this.suministro.toString() : '';
    this.globals.num_docum = this.numero_documento !== null ? this.numero_documento : '';
    if (
      this.globals.tip_docum === '' ||
      this.globals.suministro === '' ||
      this.globals.num_docum === ''
    ) {
      this.toastr.warning(
        "Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados",
        "Atención", {
        timeOut: 5000,
      });
      this.router.navigate(['']);
      return;
    }
    this.nonePoint = false;
  }

  toggle(snav: any) {
    snav.toggle();
  }

  setTitulos() {
    this.mainService.getTitulos().subscribe((response) => {
      if (response.nRESP_SP) {
        response.bRESP.forEach((e) => {
          switch (e.nombre) {
            case "TITULO":
              titulos.titulo = e.descripcion;
              break;
            case "SUBTI1":
              titulos.subtitulo1 = e.descripcion;
              break;
            case "SUBTI2":
              titulos.subtitulo2 = e.descripcion;
              break;
            default:
              titulos.marquesina = e.descripcion;
              break;
          }
        });
      }
    });
  }

  setImagenes() {
    this.mainService.getDatosImagenes().subscribe(
      (response) => {
        imagenes.urlBase = response.bRESP.base_url;
        imagenes.carpetaImagenes = response.bRESP.carpeta_imagenes;
        imagenes.logo = response.bRESP.logo_sedapal_png;
        imagenes.background = response.bRESP.inicio_imagen;
        imagenes.carousel1 = response.bRESP.carusel_1_svg;
        imagenes.carousel2 = response.bRESP.carusel_2_svg;
        imagenes.carousel3 = response.bRESP.carusel_3_svg;
        imagenes.carousel4 = response.bRESP.carusel_4_svg;
        imagenes.banner = response.bRESP.fondo_banner;
        imagenes.sidenav = response.bRESP.fondo_sidenav;
      },
      () => {
        this.openDialog.onClick({
          dialogType: "content",
          dialogSRC: "error",
          error:
            "Tenemos problemas en nuestro servidor. Por favor, actualice la página y vuelva a intentar.",
        });
      }
    );
  }

  toggleSidenav() {
    this.showFiller = !this.showFiller;
  }

  getImagenes() {
    return imagenes;
  }

  irDatoSolicitante() {
    this.nro_sumininstro = this.globals.suministro;
    this.dni = this.globals.num_docum;
    this.tip_doc = this.globals.tip_docum;
    this.tip_sol = this.globals.tipo_solicitante;
    this.estadoTramite = "";
    // this.getValidaProcesos();
  }

  getValidaProcesos() {

    let request: any = {
      numSuministro: parseInt(this.nro_sumininstro),
      tipDocumento: this.tip_doc,
      numDocumento: this.dni,
      tipSolicitante: this.tip_sol
    };
    console.log("API consulta REQUEST1: ", request);
    this.financiamientoApiService.getValidaConFinanciamiento(request).toPromise().then(
      response => {
        this.existe = response.resultado;
        console.log("existeVCF", this.existe);

        let request2: any = {
          nis_rad: this.nro_sumininstro,
          dni: this.dni,
          tip_doc: this.tip_doc,
          tip_sol: this.tip_sol
        };
        console.log("API consulta REQUEST2: ", request2);
        this.financiamientoApiService.getBandeja(request2).toPromise().then(
          response2 => {
            console.log("response2", response2);
            this.estadoTramite = response2.resultado.estadoTramite;
            this.globals.estado_tramite = this.estadoTramite;
            this.existeBand = response2.resultado.existe;
            console.log("existeBandeja", this.existeBand);
            console.log("estadoTramite", this.estadoTramite);

            let request3: any = {
              nis_rad: this.nro_sumininstro,
              dni: this.dni,
              tip_doc: this.tip_doc
            };
            console.log("API consulta REQUEST3: ", request3);
            this.financiamientoApiService.getMesesAdeudados(request3).toPromise().then(
              (response3: any) => {
                console.log("response", response3);
                this.recibos = response3.recibos;
                this.error = response3.error;
                this.lugar = response3.lugar;
                console.log("recibos", this.recibos);
                console.log("error", this.error);
                console.log("lugar", this.lugar);

                if (response3.tipo == 'v') {
                  this.globals.admin_msg_shared = 11;
                  this.router.navigate(["/mensaje-financiamiento"]);
                } else {
                  this.procesa();
                }


              }
            ).catch(error3 => {
              console.error("error3", error3);
              this.errorApiConsulta = true
              this.errorConsulta();
            });

          }
        ).catch(error2 => {
          console.error("error2", error2);
        });
      }
    ).catch(error => {
      console.error("error", error);
    });
  }

  async validaMensaje() {
    this.disabledMenu = sessionStorage.getItem('disabledMenu');
    if (this.disabledMenu == '1') {
      this.globals.nonePointer = true;
      await this.globals.nonePointer;
      this.globals.tipo_form_solicitante = 3;
      this.router.navigate(['dashboard/mensaje-financiamiento']);
      sessionStorage.setItem('router', 'dashboard/mensaje-financiamiento');
    } else {
      this.globals.nonePointer = false;
      this.globals.code_title = 1;
      this.router.navigate(['dashboard/datos-solicitante']);
    }
  }

  async reloadMensaje() {
    const router = sessionStorage.getItem('router');
    if (router) {
      this.globals.nonePointer = true;
      this.globals.tipo_form_solicitante = 3;
      await this.globals.nonePointer;
    }
  }

  errorConsulta() {
    if (this.errorApiConsulta) {
      this.globals.admin_msg_shared = 7;
      this.router.navigate(["/mensaje-financiamiento"]);
    }
  }

  procesa() {
    if (this.existe == null) {
      this.existe = 0;
    }

    if (this.existe == 1) {
      this.globals.admin_msg_shared = 2;
      this.router.navigate(["/mensaje-financiamiento"]);
    } else {
      if (this.existe == 2) {
        this.globals.admin_msg_shared = 9;
        //this.globals.admin_msg_shared = 2;
        this.router.navigate(["/mensaje-financiamiento"]);
      } else {
        if (this.existeBand) {
          if (this.estadoTramite === 'TR001' || this.estadoTramite === 'TR002') {
            this.globals.admin_msg_shared = 10;
            this.router.navigate(["/mensaje-financiamiento"]);
          } else {
            if (this.estadoTramite === 'TR004') {
              this.globals.admin_msg_shared = 5;
              this.router.navigate(["/mensaje-financiamiento"]);
            } else {
              if (this.estadoTramite === 'TR005' || this.estadoTramite === 'TR006') {
                this.globals.admin_msg_shared = 2;
                this.router.navigate(["/mensaje-financiamiento"]);
              } else {
                if (this.errorApiConsulta) {
                  this.globals.admin_msg_shared = 7;
                  this.router.navigate(["/mensaje-financiamiento"]);
                } else {
                  if (this.error && this.lugar === 'CLIENTE') {
                    if (this.globals.app_title === 'WT001') {
                      this.globals.admin_msg_shared = 10;
                      this.router.navigate(["/mensaje-financiamiento"]);
                    } else {
                      this.router.navigate(["/datos-solicitante"]);
                    }
                  } else {
                    if (this.recibos == null || this.recibos.length == 0) {
                      if (this.globals.app_title === 'WT001') {
                        this.globals.admin_msg_shared = 6;
                        this.router.navigate(["/mensaje-financiamiento"]);
                      } else {
                        this.router.navigate(["/datos-solicitante"]);
                      }
                    } else {
                      this.router.navigate(["/datos-solicitante"]);
                    }
                  }
                }
              }
            }
          }
        } else {
          if (this.errorApiConsulta) {
            this.globals.admin_msg_shared = 7;
            this.router.navigate(["/mensaje-financiamiento"]);
          } else {
            if (this.recibos == null || this.recibos.length == 0) {
              this.globals.admin_msg_shared = 6;
              this.router.navigate(["/mensaje-financiamiento"]);
            } else {
              this.router.navigate(["/datos-solicitante"]);
            }
          }
        }
      }
    }
  }

}
